import attr from "./attr";
import belongsTo from "./belongs-to";
import hasDynamicValues from "./has-dynamic-values";
import hasMany from "./has-many";

const HasManyRelation = hasMany.HasManyRelation;

export { attr, belongsTo, hasMany, hasDynamicValues, HasManyRelation };
